import Mun from "./Mun"

class Free extends Mun {
}

export default Free
